import { z } from "zod";

const NumNullableDefaultZero = z.number().nullable().default(0);

export const RentalRateSchema = z.object({
  clientId: NumNullableDefaultZero,
  locationId: NumNullableDefaultZero,
  rateId: NumNullableDefaultZero,
  vehicleTypeId: NumNullableDefaultZero,
  kMorMileageCharge: NumNullableDefaultZero,
  fuelCharge: NumNullableDefaultZero,
  hourlyRate: NumNullableDefaultZero,
  hourlyQty: NumNullableDefaultZero,
  halfDayRate: NumNullableDefaultZero,
  halfDayQty: NumNullableDefaultZero,
  dailyRate: NumNullableDefaultZero,
  dailyQty: NumNullableDefaultZero,
  weekendDayRate: NumNullableDefaultZero,
  weekendDailyQty: NumNullableDefaultZero,
  weeklyRate: NumNullableDefaultZero,
  weeklyQty: NumNullableDefaultZero,
  monthlyRate: NumNullableDefaultZero,
  monthlyQty: NumNullableDefaultZero,
  totalDays: NumNullableDefaultZero,
  extraHourlyRate: NumNullableDefaultZero,
  extraHourlyQty: NumNullableDefaultZero,
  extraDailyRate: NumNullableDefaultZero,
  extraDailyQty: NumNullableDefaultZero,
  extraWeekEndDayRate: NumNullableDefaultZero,
  extraWeekEndDayQty: NumNullableDefaultZero,
  extraWeeklyRate: NumNullableDefaultZero,
  extraWeeklyQty: NumNullableDefaultZero,
  dailyKMorMileageAllowed: NumNullableDefaultZero,
  weeklyKMorMileageAllowed: NumNullableDefaultZero,
  monthlyKMorMileageAllowed: NumNullableDefaultZero,
  totalKMorMileageAllowed: NumNullableDefaultZero,
  rateName: z.string().nullable(),
  rateValue: NumNullableDefaultZero,
  extraValue: NumNullableDefaultZero,
  howMany: NumNullableDefaultZero,
  howManyExtra: NumNullableDefaultZero,
  kmAllowed: NumNullableDefaultZero,
  isLowest: z.boolean().nullable().default(false),
  rateTotal: NumNullableDefaultZero,
  extraRateTotal: NumNullableDefaultZero,
  isDayRate: z.boolean().nullable().default(false),
  dayRates: z.any(),
  active: z.boolean().nullable(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  vehicleType: z.any(),
  graceMinutes: z.number().nullable(),
  oneWayCharge: z.number().nullable(),
  isVehicleAvailable: z.boolean().nullable().default(false),
  vehicleStatusId: z.number().nullable(),
  vehicleId: z.number().nullable(),
  isExtraMileageChargeTaxable: z.boolean().nullable().default(false),
  isExtraDayChargeTaxable: z.boolean().nullable().default(false),
  isFuelChargeTaxable: z.boolean().nullable().default(false),
  packageName: z.string().nullable(),
  packageRate: z.any(),
  packageRateId: z.number().nullable(),
  packageKMorMileageAllowed: z.number().nullable(),
  packageDaysIncluded: z.number().nullable(),
  isDayWeek: z.boolean().nullable().default(false),
  monRate: NumNullableDefaultZero,
  tuesRate: NumNullableDefaultZero,
  wedRate: NumNullableDefaultZero,
  thursRate: NumNullableDefaultZero,
  friRate: NumNullableDefaultZero,
  satRate: NumNullableDefaultZero,
  sunRate: NumNullableDefaultZero,
  monCount: NumNullableDefaultZero,
  tuesCount: NumNullableDefaultZero,
  wedCount: NumNullableDefaultZero,
  thursCount: NumNullableDefaultZero,
  friCount: NumNullableDefaultZero,
  satCount: NumNullableDefaultZero,
  sunCount: NumNullableDefaultZero,
  type: z.any(),
});
export type RentalRateParsed = z.infer<typeof RentalRateSchema>;
